import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { I18nModule } from '@spartacus/core';
import { GenFooterNavigationComponent } from './footer-navigation.component';
import { GenericLinkModule, IconModule } from '@spartacus/storefront';
import { GenNavigationUiComponent } from "./navigation-ui/navigation-ui.component";
import { GenSharedModule } from "../../../generac/shared/shared.module";

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    GenericLinkModule,
    I18nModule,
    IconModule,
    GenSharedModule
  ],
  declarations: [GenFooterNavigationComponent, GenNavigationUiComponent],
  exports: [GenFooterNavigationComponent, GenNavigationUiComponent],
})
export class GenFooterNavigationModule {}
